import React, { Component } from "react";
import { Link, withRouter } from "react-router-dom";
import { FormGroup, FormControl, Button, Alert } from "react-bootstrap";
import * as routes from "../../routes/app";
// import Chatbot from "../Chatbot/Chatbot";
import ReactGA from "react-ga";
// import NotificationSystem from "react-notification-system";
// import { style } from "variables/Variables.jsx";
import {
  customLog,
  deploymentEnvironment,
  SUPER_ADMIN_DETAILS,
} from "../../variables/Variables";
// Form CSS
import "../../assets/css/form.css";
// FB Logo White
// import fbLogoWhite from '../../assets/img/fbLogoWhite.png'
// Firebase
import firebase, {
  doSigninWithEmailPassword,
  facebookProvider,
  auth,
} from "../../firebase/index";

import ForgotPasswordModal from "./ForgotPasswordModal";

//Inline CSS

//FormControl

//FormInput types
// const formStyle = {
//   border: "5px solid #B0B0B0",
//   borderRadius: "10px",
//   width: "100%",
//   // height: '5.5em',
//   fontSize: "1.7em"
//   /*padding: "25px 20px"*/
// };

//DivContainer for forget password
// const forgetpwDivStyle = {
//   marginTop: "30px",
//   // width:"500px",
//   fontSize: "1.2em",
//   textAlign: "center",
//   alignContent: "center"
// };

// const buttonStyle = {
//   backgroundColor: "#3C3E41",
//   borderColor: "#3C3E41",
//   color: "white",
//   width: "500px",
//   borderRadius: "40px",
//   fontSize: "2.3em"
//   // boxShadow: "1px 3px 10px #B0B0B0"
// };

var trackerID = "";
if (deploymentEnvironment) {
  //! Live
  trackerID = "G-7D4M74VB11";
} else {
  //! Test
  trackerID = "G-LWK1V2E1FE";
}

const LoginPage = ({ history }) => (
  <div>
    <LoginForm history={history} />
  </div>
);

const byPropKey = (propertyName, value) => () => ({
  [propertyName]: value,
});
const INITIAL_STATE = {
  useremail: "",
  password: "",
  errorMessage: "",
};

class LoginForm extends Component {
  constructor(props) {
    super(props);
    // this.authWithFacebook = this.authWithFacebook.bind(this);
    this.state = {
      ...INITIAL_STATE,
      isLoading: false,
    };

    this.onSubmit = this.onSubmit.bind(this);
    this.handleSignUpLink = this.handleSignUpLink.bind(this);
  }

  recordLoginHistory = (uid, email) => {
    const timestamp = Math.floor(Date.now() / 1000);
    const loginInfo = {
      userEmail: email,
      platform: "WEB",
      browser: navigator.userAgent,
      timeStamp: timestamp,
    };
    firebase
      .database()
      .ref("userLoginDetails/userLoginHistory")
      .child(uid)
      .push(loginInfo);
  };

  onSubmit = (event) => {
    this.setState({ isLoading: true });
    const { useremail, password } = this.state;
    const { history } = this.props;
    const userinfo = doSigninWithEmailPassword(useremail, password)
      .then(() => {
        this.setState(() => ({ ...INITIAL_STATE }));
        const logonUid = auth.currentUser.uid;
        const logonEmail = auth.currentUser.email;

        this.recordLoginHistory(logonUid, logonEmail);

        // Step 1: check if user is a super admin by direct UID lookup
        firebase
          .database()
          .ref("groupAccounts")
          .child(logonUid)
          .once("value")
          .then((snapshot) => {
            if (snapshot.exists()) {
              customLog("User is a super admin!");
              SUPER_ADMIN_DETAILS.UUID = logonUid;
              history.push(routes.Tutorial);
            } else {
              // Step 2: not a super admin — scan members across all accounts
              firebase
                .database()
                .ref("groupAccounts")
                .once("value")
                .then((allSnapshot) => {
                  let isMemberFound = false;
                  if (allSnapshot.exists()) {
                    const snapshotDetails = allSnapshot.val();
                    outer: for (const eachSuperAdmin in snapshotDetails) {
                      const members = snapshotDetails[eachSuperAdmin].members;
                      for (const eachMember in members) {
                        const eachMemberDetails = members[eachMember];
                        if (eachMemberDetails.memberEmail === logonEmail) {
                          isMemberFound = true;
                          SUPER_ADMIN_DETAILS.UUID = eachSuperAdmin;
                          if (eachMemberDetails.isAdmin) {
                            customLog("user is an admin!");
                            history.push(routes.Dashboard);
                          } else {
                            customLog("user is a member!");
                            history.push(routes.AccountManagement);
                          }
                          break outer;
                        }
                      }
                    }
                  }
                  if (!isMemberFound) {
                    customLog("user is a new one!");
                    history.push(routes.PlanSubscription);
                  }
                });
            }
          });
        // history.push(routes.Dashboard);
      })
      .catch((error) => {
        customLog(error);
        this.setState({ errorMessage: error.message });
        this.setState({ isLoading: false });
      });

    event.preventDefault();
  };
  // authWithFacebook() {
  //   const { history } = this.props;
  //   firebase
  //     .auth()
  //     .signInWithPopup(facebookProvider)
  //     .then((result, error) => {
  //       if (error) {
  //         return (
  //           <Alert bsStyle="danger">
  //             <h4>Oh no!</h4>
  //             <p>We are unable to log you in. Please try again later</p>
  //           </Alert>
  //         );
  //       } else {
  //         history.push("/dashboard");
  //       }
  //     });
  // }

  async handleSignUpLink(event) {
    event.preventDefault(); // Prevent from page refresh

    await ReactGA.event(
      {
        category: "login_page",
        action: "enter_register_page",
        label: "signUpLink",
        value: 1,
      },
      [trackerID]
    );

    window.location.href = "/signup";
  }

  render() {
    const { useremail, password } = this.state;

    return (
      <div
        className="Login"
        // style={{ marginTop: "20vh", alignContent: "center" }}
      >
        <form>
          <h1
            style={{
              marginBottom: "70px",
              marginTop: "10px",
              // lineHeight: "10px",
              alignContent: "center",
            }}
          >
            Log In
          </h1>
          <FormGroup>
            <div className="formcontrols">
              <FormControl
                // style={formStyle}
                value={useremail}
                name={"email"}
                className={"inputText"}
                placeholder="Email Address"
                onChange={(event) =>
                  this.setState(byPropKey("useremail", event.target.value))
                }
                type="email"
              />
              <br />

              <FormControl
                // style={formStyle}
                value={password}
                id="passwordInput"
                className={"inputText"}
                name={"password"}
                placeholder="Password"
                onChange={(event) =>
                  this.setState(byPropKey("password", event.target.value))
                }
                type="password"
              />
            </div>
          </FormGroup>
          <div className="forgetpwDivStyle">
            <ForgotPasswordModal />
          </div>
          <br />

          <Button
            className="loginsignupbutton"
            // style={buttonStyle}
            disabled={this.state.isLoading}
            type="submit"
            onClick={this.onSubmit}
          >
            {this.state.isLoading ? "Loading..." : "Login"}
          </Button>

          {/* <Link id="gotoSignUp" to="/signup">
            Sign Up
          </Link> */}

          <p style={{ color: "red" }}>{this.state.errorMessage}</p>
          <br />
          <h4 style={{ textAlign: "center" }}>
            {"Don't have an account? "}
            <a href="#" onClick={this.handleSignUpLink}>
              Sign up now!
            </a>
          </h4>
        </form>
        {/* <Chatbot/> */}
      </div>
    );
  }
}

export default withRouter(LoginForm);
